// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__YJgCo","range":"MonthRangeSwitch_range__3rkmV","disabled":"MonthRangeSwitch_disabled__3m48H"};